import React, { useState, useEffect } from 'react';
import { XMLParser } from 'fast-xml-parser';
import css from './ExploreMenu.module.css';

const ExploreMenu = () => {
  const [isOpen, setIsOpen] = useState(false);
  const [sitemapLinks, setSitemapLinks] = useState([]);

  useEffect(() => {
    fetch('/suites/sitemap.xml')
      .then(res => res.text())
      .then(text => {
        const parser = new XMLParser();
        const jObj = parser.parse(text);
        const urls = new Set(jObj.urlset.url.map(u => u.loc));
        const links = Array
          .from(urls)
          .map(url => {
            try {
              const urlObject = new URL(url);
              return urlObject.pathname;
            } catch (e) {
              return null;
            }
          })
          .filter(path => path && path.startsWith('/suites') && !path.startsWith('/suites/stay'))
          .map(path => {
            const pathParts = path.split('/').filter(p => p);
            const label = pathParts[pathParts.length - 1]
              .replace(/-/g, ' ')
              .replace(/\b\w/g, l => l.toUpperCase());
            return { href: path, label };
          });

        setSitemapLinks(links);
      })
      .catch(err => {
        console.error('Error fetching sitemap:', err);
      });
  }, []);

  if (!sitemapLinks.length) return null;

  return (
    <div className={css.dropdown}>
      <button onClick={() => setIsOpen(!isOpen)} className={css.dropdownButton}>
        Explore
      </button>
      <ul className={`${css.dropdownList} ${isOpen ? css.open : ''}`}>
        {sitemapLinks.map(link => (
          <li key={link.href}>
            <a href={link.href}>{link.label}</a>
          </li>
        ))}
      </ul>
    </div>
  );
};

export default ExploreMenu; 